export const EvaluationStatusConstants = {
    FAILED: '47917D95-418B-4314-ACD5-078A8413A7AD',
    PASSED: '8E09B0A9-1579-4D17-9C47-501C1B113033',
    IN_PROGRESS: 'CB57909B-05F5-4CDF-B658-C53AB7E5CE5B',
}